import { computed } from 'vue';
import { useWindowSize } from '@vueuse/core';

// Avatar.vue nhận `size` là số rồi ghép `${size}px`, không nhận class Tailwind —
// nên ba cỡ avatar của giao diện Pancake phải tính bằng JS. Mọi số đo còn lại là
// CSS thuần, dùng biến thể `2xl:` / `3xl:` ngay tại chỗ.
//
// Ngưỡng bám đúng tailwind.config.js để CSS và JS không lệch nhau.
const BP_2XL = 1536;
const BP_3XL = 1900;

const AVATAR = {
  card: [44, 50, 56],
  header: [40, 45, 50],
  message: [28, 32, 36],
};

export function pickForWidth(steps, width) {
  if (width >= BP_3XL) return steps[2];
  if (width >= BP_2XL) return steps[1];
  return steps[0];
}

export function usePancakeMetrics() {
  const { width } = useWindowSize();
  const pick = steps => computed(() => pickForWidth(steps, width.value));

  return {
    cardAvatarSize: pick(AVATAR.card),
    headerAvatarSize: pick(AVATAR.header),
    messageAvatarSize: pick(AVATAR.message),
  };
}

export const PANCAKE_BREAKPOINTS = { BP_2XL, BP_3XL };
export const PANCAKE_AVATAR_STEPS = AVATAR;
